



import { Vue, Component } from "../../Infrastructure/CorBase/CoreBase";

@Component
export default class HomePage extends Vue {
};
